import { n as e, r as t } from "./PanelHeader-D-Qg1q2l.js";
import { Suspense as n, lazy as r, useEffect as i } from "react";
import { jsx as a } from "react/jsx-runtime";
import { Icon as o, cn as s } from "@vintecc/components";
import { faSpinner as c } from "@vintecc/pro-light-svg-icons";
//#region src/components/JsonEditor/index.tsx
var l = r(() => import("@monaco-editor/react")), u = ({ schemas: r = [], onChange: u, value: d, onValidate: f, darkMode: p = !1, disabled: m = !1 }) => (i(() => {
	(async () => {
		await t(), e().languages.json.jsonDefaults.setDiagnosticsOptions({
			validate: !0,
			schemaValidation: "error",
			schemas: r.map((e, t) => ({
				uri: e.$id || `internal://schema-${t}.json`,
				fileMatch: t === 0 ? ["*"] : void 0,
				schema: e
			}))
		});
	})();
}, [r]), /* @__PURE__ */ a(n, {
	fallback: /* @__PURE__ */ a(o, {
		icon: c,
		spin: !0
	}),
	children: /* @__PURE__ */ a(l, {
		language: "json",
		loading: null,
		theme: p ? "vs-dark" : "vs-light",
		className: s(" pt-8", {
			"bg-[#1e1e1e]": p,
			"bg-white": !p
		}),
		height: "100%",
		defaultValue: d,
		onChange: u,
		onValidate: f,
		options: {
			minimap: { enabled: !1 },
			formatOnType: !0,
			renderValidationDecorations: "on",
			readOnly: m
		}
	})
}));
//#endregion
export { u as t };

//# sourceMappingURL=JsonEditor-B1GnJRBy.js.map